// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconCaretUp: React.FC = () => {
    return (
        <svg
            width="9px"
            height="6px"
            viewBox="0 0 9 6"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            fill="currentColor"
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g
                    id="Header-+-Footer/Header/Header-:-Desktop/Desktop-:-Header-:-Authenticated"
                    transform="translate(-302.000000, -119.000000)"
                    fill="currentColor"
                    fillRule="nonzero"
                >
                    <g transform="translate(0.000000, 34.000000)">
                        <g transform="translate(0.000000, 66.000000)">
                            <g transform="translate(152.000000, 11.000000)">
                                <g transform="translate(154.366789, 10.625000) scale(1, -1) translate(-154.366789, -10.625000) translate(150.000893, 8.000000)">
                                    <path d="M8.49207639,1.49296892 L5.0166856,4.99296892 C4.82254481,5.16523421 4.59832614,5.25 4.37410748,5.25 C4.14988881,5.25 3.92621672,5.16455078 3.75531828,4.99365234 L0.279927489,1.49365234 C0.00524329798,1.24414062 -0.0696895753,0.866796792 0.0657712187,0.541406333 C0.201232013,0.216015875 0.520552155,0 0.874107059,0 L7.84949785,0 C8.20332604,0 8.52270084,0.212761879 8.65832561,0.540039062 C8.79395038,0.867316246 8.74363798,1.24414062 8.49207598,1.49296892 L8.49207639,1.49296892 Z"></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(IconCaretUp);
